import axiosInstance from "auth/FetchInterceptor";
import { LANGUAGE_LOCAL } from "constants/AuthConstant";
import {
  EMPLOYEE_API,
  EMPLOYEE_CHANGE_STATUS,
  EMPLOYEE_CREATE,
  EMPLOYEE_UPDATE,
  SEARCH_EMPLOYEE,
  SEARCH_EMPLOYEE_V2,
} from "constants/ApiConstant";
const EmployeeService = {};


EmployeeService.getEmployee = function (data) {
  return axiosInstance.post(SEARCH_EMPLOYEE, data);
};
EmployeeService.getEmployeeV2 = function (data) {
  return axiosInstance.post(SEARCH_EMPLOYEE_V2, data);
};
EmployeeService.getMobileEmployee = function (data) {
  const culture = localStorage.getItem(LANGUAGE_LOCAL) || "vi";
  return axiosInstance.post(`/${culture}/api/v1/User/mobile-employee`, data);
};
EmployeeService.createEmployee = function (data) {
  return axiosInstance.post(EMPLOYEE_CREATE, data);
};
EmployeeService.updateEmployee = function (data) {
  return axiosInstance.put(EMPLOYEE_UPDATE, data);
};
EmployeeService.changeStatusEmployee = function (data) {
  return axiosInstance.put(EMPLOYEE_CHANGE_STATUS, data);
};
EmployeeService.delEmployee = function (id) {
  return axiosInstance.delete(`${EMPLOYEE_API}/id?id=${id}`, null);
};
EmployeeService.delAccountApi = function (data) {
  return axiosInstance.post(`${EMPLOYEE_API}/delete`, data);
};

export default EmployeeService;
